import { View } from 'react-native';
import i18n from 'src/app/i18n';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import BaseModal from '../../base-modal/BaseModal';
import { useEffect } from 'react';
import { DYNAMIC_MODAL_ACTIONS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { TOAST_IDS } from '../../../toast/Toast.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { FeatureFlagAmplitude } from 'src/_shared/featureFlag';
import { SECTION_NAMES } from 'src/constants/sectionNames.contants';

export const ModalCutAlert = ({
  type,
  dynamicModalVisible,
  dynamicModalLayer: { actionCallback, id },
}: DynamicModalProps) => {
  const {
    dynamicModal: { closeModal },
    toastStore: { hideToast },
    project,
  } = useStore();

  useEffect(() => {
    amplitude.trackEvent(AnalyticsEvents.personalize.qualityAlertView, {
      mode: 'single_product',
      product_group: 'PRINT_CLASSIC',
      section_name: SECTION_NAMES.CUT_ALERT_MODAL,
      source: 'cart_add',
      text_id: 'PRINT_CLASSIC',
    });
    hideToast(TOAST_IDS.CutsCheckAlert);
    return () => {
      project.activeGroup?.checkToastNotifications();
    };
  }, []);

  const onClose = () => {
    amplitude.trackEvent(AnalyticsEvents.personalize.qualityAlertOptionClick, {
      mode: 'single_product',
      product_group: 'PRINT_CLASSIC',
      section_name: SECTION_NAMES.CUT_ALERT_MODAL,
      source: 'cart_add',
      text_id: 'PRINT_CLASSIC',
      option: 'close',
    });
    closeModal();
  };

  const isTagliVariant = amplitude.getVariantValue(FeatureFlagAmplitude.EDITOR_UNICO_TAGLI);

  return (
    <BaseModal
      testID={TestIDs.CUT_ALERT}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.Cut} />
        </View>
      }
      title={i18n.t('modal-cut-alert:title')}
      description={i18n.t('modal-cut-alert:description')}
      discardText={i18n.t(!isTagliVariant ? 'modal-cut-alert:review' : 'modal-cut-alert:continue')}
      confirmText={i18n.t(!isTagliVariant ? 'modal-cut-alert:continue' : 'modal-cut-alert:review')}
      handleDiscard={() =>
        actionCallback(!isTagliVariant ? DYNAMIC_MODAL_ACTIONS.REVIEW : DYNAMIC_MODAL_ACTIONS.CONTINUE)
      }
      handleConfirm={() =>
        actionCallback(!isTagliVariant ? DYNAMIC_MODAL_ACTIONS.CONTINUE : DYNAMIC_MODAL_ACTIONS.REVIEW)
      }
      onClose={onClose}
      onCloseOutside={onClose}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
};
